import {
  FlexChartSeries,
  FlexChartLegend,
  FlexChart,
} from "@grapecity/wijmo.react.chart";
import { useState } from "react";

import { FlexChartAnimation } from "@grapecity/wijmo.react.chart.animation";
import { ComboBox } from "@grapecity/wijmo.react.input";
import format from "date-fns/format";
import "./Chart.css";
import { Select, MenuItem, Paper } from "@mui/material";

const Chart = (props) => {
  const {
    title,
    bindingX,
    bindingSeries,
    data,
    defaultChartType = "Column",
    lastProcessDate,
  } = props;
  const [chartType, setChartType] = useState(defaultChartType);

  const handleTypeChange = (e) => {
    setChartType(e?.target.value);
  };

  return (
    <Paper elevation={3} sx={{ padding: 2, bgcolor: "#386b5c" }}>
      <Select
        value={chartType}
        size="small"
        onChange={(e) => handleTypeChange(e)}
        sx={{ marginBottom: 2, bgcolor: "#f1f1f1" }}
      >
        <MenuItem value="Bar">Bar</MenuItem>
        <MenuItem value="Line">Line</MenuItem>
        <MenuItem value="Column">Column</MenuItem>
        <MenuItem value="Scatter">Scatter</MenuItem>
        <MenuItem value="LineSymbols">LineSymbols</MenuItem>
        <MenuItem value="Area">Area</MenuItem>
        <MenuItem value="Bubble">Bubble</MenuItem>
        <MenuItem value="Candlestick">Cadlestick</MenuItem>
        <MenuItem value="HighLowOpenClose">HighLowOpenClose</MenuItem>
        <MenuItem value="Spline">Spline</MenuItem>
      </Select>
      <FlexChart
        header={title}
        chartType={chartType}
        footer={`Τελευταία ενημέρωση: ${format(
          new Date(lastProcessDate),
          "dd/MM/yyyy HH:mm"
        )}`}
        itemsSource={data}
        bindingX={bindingX}
        style={{ paddingBottom: 30, backgroundColor: "#f1f1f1" }}
      >
        {/* <wjChart.FlexChartSeries name ="test1" binding="time"/> */}
        {bindingSeries?.map((serie) => (
          <FlexChartSeries
            key={serie?.name}
            name={serie?.name}
            binding={serie?.binding}
          />
        ))}
        <FlexChartLegend position="Right" />
        <FlexChartAnimation />
      </FlexChart>
    </Paper>
  );
};

export default Chart;
